(() => {
  // One engine per section, even when Shopify reloads the script.
  if (window.beforaCarouselController) {
    window.beforaCarouselController.startAll();
    return;
  }
  const instances = new Map();
  const start = root => {
    if (!root || instances.has(root)) return;
    const viewport = root.querySelector('[data-befora-carousel-viewport]');
    const track = root.querySelector('[data-befora-carousel-track]');
    const firstGroup = track && track.querySelector('.befora-carousel__group');
    if (!viewport || !track || !firstGroup || root.dataset.autoplay !== 'true') return;
    let position = viewport.scrollLeft;
    let width = 0;
    let frame = 0;
    let lastTime = 0;
    let touching = false;
    let hovering = false;
    let resumeAt = 0;
    const speed = Number(root.dataset.speed || 18);
    const removers = [];
    const on = (target, type, fn, options) => {
      target.addEventListener(type, fn, options);
      removers.push(() => target.removeEventListener(type, fn, options));
    };
    const measure = () => {
      const previousWidth = width;
      width = firstGroup.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
      if (!width) return;
      // Include enough repeated photographs to cover even a wide viewport.
      const needed = Math.max(2, Math.ceil(viewport.clientWidth / width) + 2);
      while (track.children.length < needed) {
        const clone = firstGroup.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.beforaClone = 'true';
        clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
        clone.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
        track.appendChild(clone);
      }
      track.querySelectorAll('[aria-hidden="true"] a').forEach(a => a.tabIndex = -1);
      if (previousWidth && previousWidth !== width) position *= width / previousWidth;
      position = ((position % width) + width) % width;
      viewport.scrollLeft = position;
    };
    const pauseTouch = () => {
      touching = true;
      position = viewport.scrollLeft;
    };
    const resumeTouch = () => {
      touching = false;
      position = viewport.scrollLeft;
      resumeAt = performance.now() + 650;
    };
    on(viewport, 'touchstart', pauseTouch, { passive: true });
    on(window, 'touchend', resumeTouch, { passive: true });
    on(window, 'touchcancel', resumeTouch, { passive: true });
    // iOS can synthesize mouse hover after a touch. Only actual mouse input pauses.
    on(viewport, 'pointerenter', event => {
      if (event.pointerType === 'mouse' && matchMedia('(hover: hover) and (pointer: fine)').matches) {
        hovering = true;
        position = viewport.scrollLeft;
      }
    });
    on(viewport, 'pointerleave', event => {
      if (event.pointerType === 'mouse') hovering = false;
    });
    on(viewport, 'scroll', () => {
      if (touching || performance.now() < resumeAt || hovering) {
        position = viewport.scrollLeft;
        if (!touching && !hovering) resumeAt = performance.now() + 650;
      }
    }, { passive: true });
    on(viewport, 'wheel', () => {
      position = viewport.scrollLeft;
      resumeAt = performance.now() + 650;
    }, { passive: true });
    on(document, 'visibilitychange', () => { lastTime = 0; });
    const tick = time => {
      if (!root.isConnected) { instances.get(root)(); return; }
      const delta = lastTime ? Math.min(time - lastTime, 64) : 0;
      lastTime = time;
      if (!document.hidden && !touching && !hovering && time >= resumeAt && width > 0) {
        // Retain fractional pixels rather than reading a rounded scrollLeft every frame.
        position = ((position + speed * delta / 1000) % width + width) % width;
        viewport.scrollLeft = position;
      }
      frame = requestAnimationFrame(tick);
    };
    const observer = new ResizeObserver(measure);
    instances.set(root, () => {
      cancelAnimationFrame(frame);
      observer.disconnect();
      removers.forEach(remove => remove());
      track.querySelectorAll('[data-befora-clone]').forEach(el => el.remove());
      instances.delete(root);
      delete root.dataset.beforaCarouselStarted;
    });
    root.dataset.beforaCarouselStarted = 'true';
    measure();
    observer.observe(viewport);
    observer.observe(firstGroup);
    frame = requestAnimationFrame(tick);
  };
  const startAll = () => document.querySelectorAll('[data-befora-carousel]').forEach(start);
  window.beforaCarouselController = { startAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startAll, { once: true });
  else startAll();
  document.addEventListener('shopify:section:load', startAll);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, root) => { if (event.target.contains(root)) destroy(); });
  });
})();
